import { render, staticRenderFns } from "./CollectingBrandDataAnimation.vue?vue&type=template&id=a5226830&scoped=true"
import script from "./CollectingBrandDataAnimation.vue?vue&type=script&lang=js"
export * from "./CollectingBrandDataAnimation.vue?vue&type=script&lang=js"
import style0 from "./CollectingBrandDataAnimation.vue?vue&type=style&index=0&id=a5226830&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5226830",
  null
  
)

export default component.exports